import { connect } from 'react-redux';

import { IApplicationState } from 'shared/types/redux';

import { WorkplaceInCoworkingHeader } from '../WorkplaceInCoworkingHeader';
import { coworkingFixedWorkplaceCountSelector } from '../internal/selectors/coworkingFixedWorkplaceCountSelector';
import { coworkingFixedWorkplacePriceSelector } from '../internal/selectors/coworkingFixedWorkplacePriceSelector';
import { WorkplaceInCoworkingHeaderProps } from '../types';

export const FixedWorkplaceHeaderContainer = connect<WorkplaceInCoworkingHeaderProps, {}, {}, IApplicationState>(
  /**
   * @description Тестирование не требуется, так как селекторы и так затестированы
   */
  /* istanbul ignore next */
  state => ({
    count: coworkingFixedWorkplaceCountSelector(state),
    price: coworkingFixedWorkplacePriceSelector(state),
    title: 'Закреплённое рабочее место',
  }),
  {},
)(WorkplaceInCoworkingHeader);
